<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="custome_leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5 flex-row flex__center font-size_small">STT</div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small">Cuộc họp</div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small padding-left-10">LĐ Chỉ đạo</div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small padding-left-10">LĐ phụ trách</div>
        <div class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 font-size_small">
          Ngày chỉ đạo
          <br>Hạn hoàn thành
        </div>
        <div
          class="theTitle theTitle__lv5 flex-row flex__left padding-left-10 font-size_small"
        >Lĩnh vực</div>
        <div
          class="theTitle theTitle__lv1 flex-row flex__left padding-left-10 font-size_small"
        >Nội Dung</div>
      </div>

      <div class="custome_rightSection flex-row flex__left">
        <div class="theTitle theTitle__lv1 flex-row flex__left font-size_small">Ý kiến chỉ đạo</div>
        <div class="theTitle theTitle__lv5 flex-row flex__left font-size_small">ĐV Chủ trì</div>

        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small">Tiến độ xử lý</div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small">Đánh giá</div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small">
          Ngày kết thúc
          <br>chỉ đạo
        </div>
        <div class="theTitle theTitle__lv4 flex-row flex__left font-size_small">Ngày cập nhật</div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar class="scroll-area" :settings="perfectScrollbarSetting" infinite-wrapper>
      <div class="list-docs">
        <div
          v-for="(item, $itemIndex) in this.data"
          v-bind:key="$itemIndex"
          class="item font-size__tiny flex-row flex__between clickable"
          @click="viewDetail(item)"
        >
          <div class="custome_leftSection flex-row flex__left">
            <div class="theTitle__lv5 flex-row flex__center">
              <div class="margin-right-10">{{$itemIndex + 1}}</div>
              <el-tooltip content="Chờ báo cáo" placement="top">
                <i
                  v-if="item.state === 'Chờ báo cáo'"
                  class="far fa-play-circle color__yellow icon-status font-size__large icon-DANGTRIENKHAI"
                ></i>
              </el-tooltip>

              <el-tooltip content="Chờ phê duyệt" placement="top">
                <i
                  v-if="item.state === 'Chờ phê duyệt'"
                  class="far fa-clock color__blue icon-status font-size__large icon-CHOPHEDUYET"
                ></i>
              </el-tooltip>

              <el-tooltip content="Đã phê duyệt" placement="top">
                <i
                  v-if="item.state === 'Đã phê duyệt'"
                  class="fas fa-check-circle color__green icon-status font-size__large icon-HOANTHANH"
                ></i>
              </el-tooltip>

              <el-tooltip content="Đã hủy" placement="top">
                <i
                  v-if="item.state === 'Hủy yêu cầu'"
                  class="far fa-times-circle color__red icon-status font-size__large icon-HUY"
                ></i>
              </el-tooltip>
            </div>
            <div class="theTitle__lv4 margin-right-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable bold-text">{{item.meeting}}</div>
              </div>
            </div>
            <div
              class="theTitle__lv4 flex-row flex__left padding-right-10"
            >{{item.directiveFullName}}</div>
            <div class="theTitle__lv4 flex-row flex__left padding-right-10">{{item.performFullName}}</div>
            <div class="theTitle__lv3 flex-row flex__left">
              - {{convertTime(item.commandsDate)}}
              <br>
              - {{item.deadline ? convertTime(item.deadline) : null}}
            </div>
            <div class="theTitle__lv5 flex-row flex__left">{{item.sector}}</div>
            <div class="theTitle__lv1 flex-row flex__left padding-right-10">{{item.conclusion}}</div>
          </div>
          <div class="custome_rightSection flex-row flex__right">
            <div class="theTitle__lv1 flex-row flex__left">{{item.directionContent}}</div>
            <div class="theTitle__lv5 flex-row flex__left">{{item.deptName}}</div>

            <div class="theTitle__lv4 flex-col flex_center">
              <el-tag
                v-if="item.commandsStatus === 'PROCESSING'"
                size="mini"
                :class="['priority','font-size__tiny','lv2']"
              >Đang xử lý</el-tag>
              <el-tag
                v-if="item.commandsStatus === 'COMPLETE'"
                size="mini"
                :class="['priority','font-size__tiny','lv4']"
              >Hoàn thành</el-tag>
              <el-tag
                v-if="item.commandsStatus === 'USUALLY'"
                size="mini"
                :class="['priority','font-size__tiny','lv3']"
              >CV hằng ngày</el-tag>
            </div>

            <div class="theTitle__lv4 flex-col flex_center">
              <el-tag
                v-if="item.progress === 'LATE'"
                size="mini"
                :class="['priority','font-size__tiny','lv1']"
              >Chậm tiến độ</el-tag>
              <el-tag
                v-if="item.progress === 'ON_TIME'"
                size="mini"
                :class="['priority','font-size__tiny','lv4']"
              >Đúng hạn</el-tag>
            </div>

            <div
              class="theTitle__lv4 flex-row flex__left"
            >{{item.finishDate ? convertTime(item.finishDate) : null}}</div>

            <div class="theTitle__lv4 flex-row flex__left">{{convertTime(item.updateTime)}}</div>

            <div v-if="hcFlow" class="theQuickAction flex-row flex__right">
              <el-tooltip
                v-if="item.state !== 'Hủy yêu cầu'"
                @click.native.stop="openDeclineDialog(item)"
                content="Hủy yêu cầu"
                placement="top"
              >
                <i class="action-icon bgAmbient__red clickable fas fa-ban"></i>
              </el-tooltip>
            </div>
          </div>
        </div>

        <infinite-loading ref="infiniteLoading" spinner="spiral" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div class="flex-row flex__center" v-if="this.data.length === 0">Không có dữ liệu</div>
      </div>
    </VuePerfectScrollbar>

    <declineDialog
      :isOpen="isOpenDeclineDialog"
      v-if="isEnableDeclineDialog"
      :data="item"
      @dialogClosed="isEnableDeclineDialog = false"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";
import declineDialog from "./ketLuanChiDao_TuChoiDialog";
import moment from "moment";
export default {
  props: ["data", "hcFlow"],
  components: {
    VuePerfectScrollbar,
    declineDialog,
    InfiniteLoading
  },
  filters: { dateFormatter },
  watch: {
    data(newValue) {
      if (newValue !== this.data) {
        this.data = newValue;
      }
    },
    isOpenDeclineDialog(newValue) {
      newValue && (this.isEnableDeclineDialog = newValue);
    },
    isEnableDeclineDialog(newValue) {
      !newValue && (this.selectdItem = null);
    }
  },
  data() {
    return {
      isEnableDeclineDialog: false,
      isOpenDeclineDialog: false,
      selectdItem: null,
      item: null
    };
  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetail", {
        caseMasterId: item.caseMasterId
      });
    },

    infiniteHandler($state) {
      this.$emit("infiniteHandler", $state);
    },

    convertTime(time) {
      return moment(time).format("DD/MM/YYYY");
    },

    openDeclineDialog(item) {
      this.isOpenDeclineDialog = true;
      this.item = item;
    },

    closeDialog(respone) {
      if (respone) {
        this.isOpenDeclineDialog = false;
        this.$emit("reload");
      } else {
        this.isOpenDeclineDialog = false;
      }
    }
  }
};
</script>

<style scoped>
.bold-text {
  font-weight: 500 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/ketLuanChiDao_MainContent.vue